import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import Url from 'environment';
import style from './style.module.scss';
import LolViewSetPick from './pick';
import LolViewBan from './ban';

const LolViewSet = observer(({ item }) => {
  const { killScore, getSetTeamData, displayTime, win } = item;
  const { home, away } = getSetTeamData;

  return (
    <div className={style.detail_score}>
      <div className={style.info}>
        <div className={style.kill_score}>{killScore}</div>
        <div className={style.time}>{displayTime}</div>
        <div className={style.top}>
          <div className={clsx(style.item, style.left)}>
            <span className={style.nick}>소환사명</span>
            <span className={style.champ}>챔피언</span>
            <span className={style.kda}>K/D/A</span>
          </div>
          <div className={clsx(style.item, style.right)}>
            <span className={style.kda}>K/D/A</span>
            <span className={style.champ}>챔피언</span>
            <span className={style.nick}>소환사명</span>
          </div>
        </div>
        <div className={style.middle}>
          <div className={style.inner}>
            <span>탑</span>
            <span>정글</span>
            <span>미드</span>
            <span>원딜</span>
            <span>서포트</span>
          </div>
          <div className={style.ban}>BAN</div>
        </div>
      </div>

      {/* home */}
      <div className={clsx(style.team, style.left)}>
        {win.home && <span className={style.result}>승</span>}
        <div className={style.team_name}>
          <img src={`${Url.thumb}/0x35${home.imgPath}`} alt='team logo' />
          <span>{home.name.length > 8 ? home.name.slice(0, 6) + '..' : home.name}</span>
        </div>
        <dl className={style.stat}>
          <dt>골드</dt>
          <dd>{home.gold}</dd>
          <dt>포탑</dt>
          <dd>{home.tower}</dd>
          <dt>바론</dt>
          <dd>{home.baron}</dd>
          <dt>용</dt>
          <dd>{home.dragon}</dd>
        </dl>
        <div className={style.special}>
          <span className={clsx(home.firstBlood && style.on)}>첫 킬</span>
          <span className={clsx(home.first10Kill && style.on)}>첫 10킬</span>
          <span className={clsx(home.firstTower && style.on)}>첫 타워</span>
          <span className={clsx(home.firstDragon && style.on)}>첫 용</span>
          <span className={clsx(home.firstBaron && style.on)}>첫 바론</span>
        </div>
        <LolViewSetPick players={home.players} />

        <div className={style.ban}>
          {home.banPicks.map((item, idx) => {
            // console.log('home - ban = ', item);
            return <LolViewBan item={item} key={idx} />;
          })}
        </div>
      </div>

      {/* away */}
      <div className={clsx(style.team, style.right)}>
        {win.away && <span className={style.result}>승</span>}
        <div className={style.team_name}>
          <img src={`${Url.thumb}/0x35${away.imgPath}`} alt='team logo' />
          <span>{away.name.length > 9 ? away.name.slice(0, 8) + '..' : away.name}</span>
        </div>
        <dl className={style.stat}>
          <dt>골드</dt>
          <dd>{away.gold}</dd>
          <dt>포탑</dt>
          <dd>{away.tower}</dd>
          <dt>바론</dt>
          <dd>{away.baron}</dd>
          <dt>용</dt>
          <dd>{away.dragon}</dd>
        </dl>
        <div className={style.special}>
          <span className={clsx(away.firstBlood && style.on)}>첫 킬</span>
          <span className={clsx(away.first10Kill && style.on)}>첫 10킬</span>
          <span className={clsx(away.firstTower && style.on)}>첫 타워</span>
          <span className={clsx(away.firstDragon && style.on)}>첫 용</span>
          <span className={clsx(away.firstBaron && style.on)}>첫 바론</span>
        </div>
        <LolViewSetPick players={away.players} />

        <div className={style.ban}>
          {away.banPicks.map((item, idx) => {
            // console.log('away - ban = ', item)
            return <LolViewBan item={item} key={idx} />;
          })}
        </div>
      </div>
    </div>
  );
});

export default LolViewSet;
